import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    innerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      padding: '32px 64px 40px 64px',
      [theme.breakpoints.down('lg')]: {
        height: '1640px'
      }
    },
    headerBlock: {
      background: 'transparent',
      minWidth: '100%',
      flex: '0 1 auto',
      height: 'auto',
      minHeight: '101px',
      maxHeight: '172px',
      [theme.breakpoints.down('lg')]: {
        minHeight: '280px',
        maxHeight: '310px'
      }
    },
    cardContainer: {
      display: 'flex',
      justifyContent: 'center',
      height: '461px',
      background: 'transparent',
      flexDirection: 'row',
      marginBottom: '40px',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        height: 'fit-content',
        marginBottom: '23px'
      }
    },
    cardBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 16px 0px 16px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        margin: '20px 0',
        padding: '0px'
      }
    },
    cardContent: {
      flexDirection: 'column',
      width: '365px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        width: '755px',
        height: '250px'
      }
    },
    cardImage: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '275px',
      background: 'transparent',
      overflow: 'hidden',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        width: '333px',
        height: '100%',
        alignItems: 'normal'
      }
    },
    defaultImage: {
      height: '100%',
      objectFit: 'cover',
      [theme.breakpoints.down('lg')]: {
        width: 'auto'
      }
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '8px 8px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        borderRadius: '8px 0px 0px 8px'
      }
    },
    horizontalDivider: {
      marginTop: '-1px',
      padding: '0px 24px',
      background: 'transparent',
      maxHeight: '5px',
      display: 'block',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    verticalDivider: {
      display: 'none',
      margin: '0px 32px 0px 0px',
      background: 'rgba(155,155,155)',
      height: '248px',
      width: '1px',
      [theme.breakpoints.down('lg')]: {
        display: 'block'
      }
    },
    cardText: {
      display: 'flex',
      justifyContent: 'space-around',
      height: '185px',
      background: 'transparent',
      padding: '10px 24px',
      alignItems: 'stretch',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
        width: '371px',
        padding: '0px 10px 0px 10px',
        height: '100%'
      }
    },
    noProductsBlock: {
      height: '415px',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        height: 'max-content',
        padding: '0px 0px 114px 0px'
      }
    },
    noProductsImage: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      padding: '64px 0px 24px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 49px 0px'
      }
    },
    headerText: {
      [theme.breakpoints.down('lg')]: {
        width: '100% !important',
        minHeight: '100px',
        maxHeight: '240px'
      }
    },
    cartError: {
      width: '910px',
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.down('lg')]: {
        width: '600px'
      }
    }
  })
);
